function stylesheet(useActualHostSelector, token) {
  var shadowSelector = token ? ("[" + token + "]") : "";
  var hostSelector = token ? ("[" + token + "-host]") : "";
  return [".toggle-option_align", shadowSelector, " {position: absolute;left: 94.5%;width: 15%;font-weight: bold;}.view-as_img", shadowSelector, " {height: 32px;cursor: pointer;border: 6px solid transparent;border-radius: 5px;margin-right: 8px;}.header-bottom__align", shadowSelector, " {box-shadow: 0 0 0 0 rgb(0 0 0 / 10);}"].join('');
}
export default [stylesheet];